import api from "../api";

export const userNotifications = async () => {
  return api
    .get("/v0/user/notifications", {
      headers: {
        "x-access-token": localStorage.getItem("@App:token"),
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
};

export const updateUserAccount = async (payload) => {
  return api
    .put("/v0/user", payload)
    .then((response) => response)
    .catch((error) => error.response);
};

export const userPayments = async () => {
  return api
    .get("/v0/user/payments")
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const insertCredits = async (payload) => {
  return api
    .post("/v0/user/insert-credits", payload)
    .then((response) => response.data)
    .catch((error) => error.response);
}

export const attachPaymentMethod = async (payload) => {
  return api
    .post("/v0/user/attach-payment", payload)
    .then((response) => response)
}

export const getPaymentMethods = async () => {
  return api
    .get("/v0/user/payment_methods")
    .then((response) => response.data);
    // .catch((error) => error.response);
}

export const removePaymentMethod = async (id) => {
  return api
    .delete("/v0/user/payment/" + id)
    .then((response) => response.data);
    // .catch((error) => error.response);
}

export const updateRenewAmount = async (data) => {
  return api
    .put("/v0/user/renew-amount", data)
    .then((response) => response.data);
    // .catch((error) => error.response);
}

export const partnerInvites = async () => {
  return api.get("/v0/user/invites").then((res) => res.data);
};

export const sendInvite = async (payload) => {
  return api.post("/v0/user/send-invite", payload).then((res) => res.data);
};

export const updateMemberRole = async (email, payload) => {
    return api.patch(`/v0/user/${email}/role`, payload).then((res) => res.data);
};

export const deleteMember = async (email) => {
  return api.delete(`/v0/user/${email}`).then((res) => res.data);
};

export const getRoles = async () => {
  return api.get("/v0/user/roles").then((res) => res.data);
};

export const validateInvite = async (code) => {
  return api.get("/v0/user/invite/" + code).then((res) => res.data);
};

export const deleteInvite = async (email) => {
  return api.delete(`/v0/user/${email}/invites`).then((res) => res.data);
};

export const listProductionKeys = async (workspaceId) => {
  return api.get(`/v0/partner/${workspaceId}/credentials/production`).then((res) => res.data);
};

export const generateProductionKey = async () => {
  return api.post("/v0/user/production-keys").then((res) => res.data);
};

export const listSandboxKeys = async (workspaceId) => {
  return api
    .get(`/v0/partner/${workspaceId}/credentials/sandbox`, {
      headers: {
        "x-access-token": localStorage.getItem("@App:token"),
      },
    })
    .then((res) => res.data);
};

export const generateSandboxKey = async () => {
  return api.post("/v0/user/sandbox-keys").then((res) => res.data);
};

export const removeMember = async (memberId) => {
    return api.delete(`/v0/partner/${memberId}`);
}

